module.exports = __webpack_public_path__ + "static/media/data_analytics__monochromatic.3a967496.png";